import { env } from "@/constants/env";
import { Capacitor } from "@capacitor/core";

/** Uses the effect's captured auth token, never mutable global request identity. */
export async function syncAnalyticsEligibility(
  enabled: boolean,
  token: string,
  signal: AbortSignal,
): Promise<void> {
  if (env.MODE !== "production" || signal.aborted) return;
  const platform = Capacitor.getPlatform();
  if (!["ios", "android", "web"].includes(platform)) return;
  const response = await fetch(`${env.VITE_API_URL}/api/v1/analytics/eligibility`, {
    method: "PUT",
    signal,
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
      "x-api-key": env.VITE_API_KEY,
    },
    body: JSON.stringify({ platform, enabled, policy_version: "product_analytics_v2" }),
  });
  if (!response.ok) throw new Error("Eligibility sync failed");
}
